module.exports = __webpack_public_path__ + "img/81.4607c681.jpg";